import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import styles from "./styles";
import * as actionsPresentacion from "../../../../actions/nuevaPresentacion";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Container, Typography, MenuItem } from "@material-ui/core";
import { TextFieldCustom } from "../../../common/UI/Personalizaciones/TextField";

const TipoPresentacion = (props) => {
    const classes = styles();

    const tipoPresentacionHandler = useCallback(
        (tipoPresentacionId) => {
            props.seleccionarTipoDePresentacion(tipoPresentacionId);

            const requeridos = tipoPresentacionId === 1;

            const reqTComprobante = (props.tipoComprobanteSeleccionado === "" || props.tipoComprobanteSeleccionado === 1) &&  tipoPresentacionId === 1 ? (props.tipoComprobanteSeleccionado === "" ||  props.tipoComprobanteSeleccionado === 1) : false ;

            const reqFactura = requeridos && reqTComprobante;
            const reqLiquidaciones = tipoPresentacionId === 2;
            const reqObrasSociales = tipoPresentacionId === 3;
            props.actualizarRequeridos("tipoComprobante", requeridos);
            props.actualizarRequeridos("codComprobante", requeridos);
            props.actualizarRequeridos("nroComprobante", requeridos);
            props.actualizarRequeridos("facturas", requeridos);
            props.actualizarRequeridos("liquidaciones", reqFactura);
            props.actualizarRequeridos("imagenes", reqObrasSociales)
            props.actualizarRequeridos("prestaciones", reqFactura || reqLiquidaciones || reqObrasSociales);

            const reqInternaciones =
                props.tipoPrestacionSeleccionada === 2 &&
                reqTComprobante &&
                tipoPresentacionId === 1 &&
                !props.prestadorActivo.obraSocial;

            props.actualizarRequeridos("internaciones", reqInternaciones);

            props.actualizarRequeridosEsValido("tipoPresentacion", true);
    
            props.buscarTiposPrestaciones(tipoPresentacionId);
            props.buscarTiposComprobantes(tipoPresentacionId);
        },
        [props.tipoPrestacionSeleccionada,props.buscarTiposPrestaciones,props.buscarTiposComprobantes]
    );

    useEffect(() => {
        if (
            props.prestadorActivo &&
            props.prestadorActivo.tipoPresentacion &&
            props.prestadorActivo.tipoPresentacion !== 3 &&
            !props.prestadorActivo.obraSocial
        ) {
            tipoPresentacionHandler(props.prestadorActivo.tipoPresentacion);
        }
    }, [props.prestadorActivo, tipoPresentacionHandler]);

    const dibujarSelecionarTipoPresentacion = () => {
        if (
            !props.prestadorActivo ||
            !props.prestadorSeleccionado ||
            (props.prestadorActivo.tipoPresentacion &&
                props.prestadorActivo.tipoPresentacion !== 3 && !props.prestadorActivo.obraSocial) 
             
        ) {
            return null;
        }

        const presentacionesAMostrar = props.tipoPresentaciones.filter(tp => {
            if(!props.prestadorActivo.obraSocial && tp.id == 3) {
                return false;
            }
            if(props.prestadorActivo.tipoPresentacion == 2 && tp.id == 1) {
                return false;
            }
            if(props.prestadorActivo.tipoPresentacion == 1 && tp.id == 2) {
                return false;
            }
            return true;
        });
        if(presentacionesAMostrar.length <= 1) {
            return null;
        }

        const tipo = props.tipoPresentaciones.find(
            (t) => t.id === props.tipoPresentacionSeleccionada
        );
        const inputValue = tipo ? tipo.descripcion : "";

        return (
            <Container disableGutters={true} className={classes.container}>
            <TextFieldCustom
                className={classes.textField}
                select={!props.soloVista}
                variant="outlined"
                label="Tipo de Presentación"
                size="small"
                required={!props.soloVista}
                value={
                    props.soloVista
                        ? inputValue
                        : props.tipoPresentacionSeleccionada
                }
                disabled={props.estaVinculada && !props.soloVista}
                inputProps={{ readOnly: props.soloVista }}
                SelectProps={{
                    IconComponent: (props) => (
                        <KeyboardArrowDownIcon
                            fontSize="small"
                            className={`${classes.dropDownIcon}, ${props.className}`}
                        />
                    ),
                }}
                onChange={(event) =>
                    tipoPresentacionHandler(event.target.value)
                }
                onBlur={() =>
                    props.actualizarMensajesError(
                        "tipoPresentacion",
                        !props.tipoPresentacionSeleccionada
                            ? "Debe seleccionar una opción"
                            : null
                    )
                }
                error={!!props.errorMensaje.tipoPresentacion}
                helperText={
                    props.errorMensaje.tipoPresentacion &&
                    props.errorMensaje.tipoPresentacion
                }
            >
                {presentacionesAMostrar.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.descripcion}
                    </MenuItem>
                ))}
            </TextFieldCustom>
            </Container>
        );
    };

    return (
        <>
            <div>{dibujarSelecionarTipoPresentacion()}</div>
        </>            
     
    );
};

const mapStateToProps = (state) => ({
    prestadorActivo: state.authReducer.prestadorActivo,
    prestadorSeleccionado: state.nuevaPresentacionReducer.prestadorSeleccionado,
    tipoPresentaciones: state.nuevaPresentacionReducer.tipoPresentaciones,
    tipoPrestacionSeleccionada:
        state.nuevaPresentacionReducer.tipoPrestacionSeleccionada,
    tipoPresentacionSeleccionada:
        state.nuevaPresentacionReducer.tipoPresentacionSeleccionada,
    tipoComprobanteSeleccionado:
        state.nuevaPresentacionReducer.tipoComprobantesSeleccionado,
    errorMensaje: state.nuevaPresentacionReducer.errorMensaje,
    estaVinculada: state.nuevaPresentacionReducer.estaVinculada,
    soloVista: state.nuevaPresentacionReducer.soloVista,
});

const actionCreators = {
    seleccionarTipoDePresentacion:
        actionsPresentacion.seleccionarTipoDePresentacion,
    actualizarRequeridosEsValido:
        actionsPresentacion.actualizarRequeridosEsValido,
    actualizarRequeridos: actionsPresentacion.actualizarRequeridos,
    actualizarMensajesError: actionsPresentacion.actualizarMensajesError,
    buscarTiposPrestaciones: actionsPresentacion.buscarTiposPrestacionesPresentacion,
    buscarTiposComprobantes: actionsPresentacion.buscarTiposComprobantesPresentacion,
    
    
};

export default connect(mapStateToProps, actionCreators)(TipoPresentacion);
